/**
 * TaoPromise Utility.
 *
 */
const TaoPromise = {};

/**
 * Works like Promise.race, but adds additional cleanup step, after the first promise resolves.
 *
 * @param {Function} callback Callback Function(s) to execute.
 * @return {Promise}           Executed Promise.race resolving to the first finished promise.
 */
TaoPromise.cleanRace = ( callback ) => {
	// Map all to promises and get their cleanup functions.
	const callbacks = [].concat( callback ).map(
		( promiseFn ) => {
			let cleanupFn = () => {};
			return [
				new Promise( ( resolve, reject ) => {
					cleanupFn = promiseFn( resolve, reject ) || ( () => {} );
				} ),
				cleanupFn,
			];
		},
	);

	const promises = callbacks.map( ( [ promise ] ) => promise );
	const cleanups = callbacks.map( ( [ , cleanup ] ) => cleanup );

	return Promise.race( promises )
		.finally( ( res ) => {
			// Run all cleanup functions.
			cleanups.forEach( ( fn ) => fn() );

			// Return return value.
			return res;
		} );
};

/**
 * Add callback functions
 *
 * @param {Function} callback Callback Function(s) to execute.
 * @param {number}   timeout  Additional timeout.
 * @return {Promise}          Executed Promise.race resolving to the first finished promise.
 */
TaoPromise.timeout = ( callback, timeout = 0 ) => {
	// Create timeout function with cleanup func.
	const timeoutFn = ( resolve ) => {
		const tout = setTimeout( () => resolve(), timeout );
		return () => clearTimeout( tout );
	};

	// Generate List of all Callback Functions.
	const callbacks = [].concat( callback ).concat( timeoutFn );
	return TaoPromise.cleanRace( callbacks );
};

export default TaoPromise;
